<template>
    <div id="autocomplete_component" class="form-item">
        <label :for="'autocomplete_field_' + fieldKey"
               class="form-label"
               v-html="label"></label>
        <div class="select-outer select-outer--autocomplete"
             :class="{ 'field-error': errors.has(fieldKey) && showErrors, 'disabled': disabled }">
            <input type="text"
                   :id="'autocomplete_field_' + fieldKey"
                   :name="fieldKey"
                   v-model="selected"
                   v-validate="rules"
                   :disabled="disabled"
                   @focus="openDropdown()"
                   @blur="openList = hoverList ? openDropdown() : closeDropdown()"
                   @keydown="keydownEvent($event)"
                   @keyup="openDropdown()">
            <ul v-show="isOpened() && !disabled && selected && autocomplete.length > 0 && (autocomplete[0].name !== selected)">
                <li v-for="(value, index) in autocomplete"
                    :class="{ 'active' : itemHovered === index }"
                    @click="select(value.name), closeDropdown()"
                    @mouseover="hoverList = true, itemHover(index)"
                    @mouseleave="hoverList = false">
                    {{ value.name }}
                </li>
            </ul>
            <p class="field-error--description" v-show="errors.has(fieldKey) && showErrors">{{ errors.first(fieldKey) }}</p>
        </div>
    </div>
</template>
<script>
    export default {
        inject: ['$validator'],
        props: ['defaultValue', 'disabled', 'fieldKey', 'label', 'list', 'rules', 'showErrors', 'updateValue'],
        data () {
            return {
                selected: '',
                index: 0,
                sending: false,
                opened: false,
                hoverList   : false,
                itemHovered: null
            }
        },
        computed: {
            autocomplete () {
                let list        = this.list,
                    selected    = this.selected.toLowerCase();
                if (!selected) {
                    return list;
                } else {
                    this.itemHover(0);
                    return list.filter(function (obj) {
                        let name = obj.name.toLowerCase(),
                            len  = selected.length;

                        return name.substring(0, len) === selected;
                    }).slice(0,6);
                }
            }
        },
        methods: {
            keydownEvent(event) {
                // Do not lost focus when tab key used
                if(event.key === 'Tab') {
                    this.selectNext();
                    event.preventDefault();
                }

                // Autocomplete when press enter
                if(event.key === 'Enter') {
                    this.selected = this.autocomplete[this.itemHovered].name;
                    this.closeDropdown();
                }
            },
            itemHover (index) {
                this.itemHovered = index;
            },
            selectNext () {
                let len = this.autocomplete.length;

                if (len <= this.itemHovered + 1) {
                    this.itemHovered = 0;
                    this.itemHover(0);
                } else {
                    this.itemHovered++;
                }
            },
            selectFirst () {
                this.itemHovered = 0;
            },
            select (value) {
                this.selected = value;
            },
            isOpened() {
                return this.opened
            },
            openDropdown() {
                this.opened = true;
            },
            closeDropdown() {
                this.opened = false;
            }
        },
        watch: {
            selected () {
                this.updateValue(this.fieldKey, this.selected);
            }
        },
        mounted () {
            this.selected = this.defaultValue;
        }
    }
</script>

<style lang="scss" scoped>

    @import '../../../assets/scss/_colors.scss';

    .select-outer {
        ul {
            z-index: 11;
            li {
                &.active,
                &.active:hover {
                     background: $base1;
                     color: $white;
                }
                &:hover {
                     background: transparent;
                     color: $black;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/shared/autocomplete/Autocomplete.component.vue